import { useState, useEffect } from 'react';

export const useUrlValidation = (url: string, validUrlPattern: string) => {
  const [isValid, setIsValid] = useState(null);

  useEffect(() => {
    const pattern = new RegExp(validUrlPattern);

    setIsValid(pattern.test(url.trim()));
  }, [url]);

  return [isValid];
};
